import ajaxChimp from './ajax-chimp'

const $wrap = $('#SubscribeMiniWrap')
const $btnClose = $wrap.find('.subscribe-mini__btn-close')

const $form = $('#MiniSubscribeForm')
const $emailInput = $form.find('input#mce-EMAIL')
const $submitInput = $form.find('input[type="submit"]')
const $formIntro = $('.subscribe-mini-form-info')

const CLASSES = {
  WRAP_IS_VISIBLE: 'subscribe-mini-wrap--is-visible',
  INTRO_IS_VISIBLE: 'subscribe-mini-form-info--is-visible',
  INTRO_IS_SUCCESS: 'subscribe-mini-form-info--is-success',
  INTRO_IS_ERROR: 'subscribe-mini-form-info--is-error',
}

const anchorRegEx = /<\/?a(|\s+[^>]+)>/;

export default function() {
  $btnClose.on('click', hideForm)

  $formIntro.on('click', function(event) {
    $(this).removeClass(CLASSES.INTRO_IS_VISIBLE)
  })

  $form.on('submit', function(event) {
    event.preventDefault()
    submitForm()
  })
}

function submitForm() {

  const url = $form.attr('action')
  let data = {}
  $.each($form.serializeArray(), (index, item) => data[item.name] = item.value)

  ajaxChimp(url, data).done(function(response) {
    let responseMsg

    if (response.result === 'success') {
      responseMsg = 'Verification email sent'
      $formIntro.addClass(CLASSES.INTRO_IS_SUCCESS)
    } else if (response.msg && anchorRegEx.test(response.msg) === false) {
      // ^ regex test to ignore any 'complicated' messages (i.e., those w/ links)
      responseMsg = response.msg.substr(4) // remove `0 - `
    } else {
      responseMsg = 'Unable to subscribe'
    }

    if (responseMsg.length) {
      $formIntro.text(responseMsg).addClass(CLASSES.INTRO_IS_VISIBLE)
    }

    setTimeout(function () {
      $emailInput.val('')

      if (response.result === 'success') {
        hideForm()
      } else {
        $formIntro.text('')
          .removeClass(CLASSES.INTRO_IS_VISIBLE)
          .removeClass(CLASSES.INTRO_IS_ERROR)
      }
    }, 1750)

  })
}

function hideForm() {
  $wrap.removeClass(CLASSES.WRAP_IS_VISIBLE)
}


// WEBPACK FOOTER //
// ./subscribe-mini.js